import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPTReportsData } from "../../../redux/reducers/apiSlice";
import UserProfile from "../../pt-trials/UserProfile";
import "../../../styles/trainer-member/tme-details.css";
import CalendarLoader from "../../common-components/CalendarLoader";

const TMEPTTrackDetails = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const token = userInfoData?.token;

  const { ptReportsLoading, ptReportsData, ptReportError } = useSelector(
    (state) => state.api
  );

  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (rowData?.user_id && token) {
      const queryParameters = `user_id=${rowData.user_id}`;

      dispatch(
        fetchPTReportsData({
          pageNo: 1,
          limit: 1,
          queryParameters: queryParameters,
          token: token,
        })
      );
    }
  }, [rowData?.uid]);

  useEffect(() => {
    if (
      !ptReportsLoading &&
      !ptReportError &&
      ptReportsData?.status &&
      ptReportsData?.data?.length > 0
    ) {
      setUserData(ptReportsData.data[0]);
    } else if (ptReportError || ptReportsData?.status === false) {
      setUserData(null);
    }
  }, [ptReportsLoading, ptReportsData, ptReportError]);

  if (ptReportsLoading) {
    return (
      <div className="loading-container">
        <p>Loading member profile...</p>
      </div>
    );
  }

  if (!ptReportsLoading && (ptReportError || !userData)) {
    return (
      <div className="error-container">
        <p>No PT track details found for this member.</p>
      </div>
    );
  }

  return (
    <div className="tme-pt-track-details-container">
      {ptReportsLoading ? (
        <CalendarLoader className="weekly-roster-overview-grid" />
      ) : (
        <UserProfile userData={userData} />
      )}
    </div>
  );
};

export default TMEPTTrackDetails;
